import { getAttributeValue } from '@canvas-logic/clp-domain';
export class DynamicValueService {
    constructor(pipeRegistry) {
        this.pipeRegistry = pipeRegistry;
    }
    calculate(value, model) {
        switch (value.type) {
            case 'constant':
                return value.value;
            case 'attributeValue': {
                return this.getAttributeValue(model, value);
            }
            case 'tableValue': {
                return this.getTableValue(model, value);
            }
        }
    }
    getAttributeValue(model, value) {
        const component = model[value.componentKey];
        if (component === null) {
            throw new Error(`Component ${value.componentKey} not found in model`);
        }
        const dtoValue = component[value.attributeKey];
        let attributeValue = getAttributeValue(dtoValue);
        if (value.pipes) {
            attributeValue = this.pipeRegistry.runPipeN(value.pipes, attributeValue, value);
        }
        return attributeValue;
    }
    getTableValue(model, value) {
        const fieldValues = value.columns.map((column) => this.getColumnValue(column, model));
        const matchedRecord = value.data.find((record) => {
            if (isEqualFirstElements(record, fieldValues, fieldValues.length)) {
                return record;
            }
        });
        return matchedRecord ? getRecordOutputValue(matchedRecord) : value.fallbackValue;
    }
    getColumnValue(column, model) {
        const component = model[column.componentKey];
        if (component === null) {
            throw new Error(`Component ${column.componentKey} not found in model`);
        }
        const dtoValue = component[column.attributeKey];
        return getAttributeValue(dtoValue);
    }
}
function isEqualFirstElements(xs, ys, count) {
    for (let i = 0; i < count; i++) {
        if (xs[i] != ys[i] && xs[i] !== '*') {
            return false;
        }
    }
    return true;
}
function getRecordOutputValue(record) {
    return record[record.length - 1];
}
//# sourceMappingURL=index.js.map